export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00796.7fb81ac3.png";